<script>
export default {
    props: {
        username: String,
        image: String,
    },
    computed: {
        firstChar() {
            if (this.username.trim().length) {
                return this.username.trim().toUpperCase()[0];
            } else {
                return '?';
            }
        },
    },
}
</script>

<template>
    <span class="Avatar">{{ firstChar }}</span>
</template>

<style lang="stylus" scoped>
.Avatar
    display inline-flex
    justify-content center
    align-items center
    height 42px
    width 42px
    background #181834
    color #fff
    box-shadow 0 0 50px rgba(0,0,0,.4)
</style>

